// extracted by mini-css-extract-plugin
export default {"tv_loader__wrapper":"Loader_tv_loader__wrapper__NYFMd","overlay":"Loader_overlay__GxroS","full_screen":"Loader_full_screen__T7D1M","spinner":"Loader_spinner__e7xTm"};